import { SelectableCard } from './SelectableCard';

interface Step5BudgetProps {
    title: string;
    helperText: string;
    options: string[];
    value: string | null;
    onSelect: (title: string) => void;
}

export const Step5Budget = ({
    title,
    helperText,
    options,
    value,
    onSelect,
}: Step5BudgetProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <h2 className="text-[1.3125rem] leading-[1.1] font-medium tracking-[-0.02em] text-[#161616] uppercase">
                {title}
            </h2>
            <p className="text-[0.75rem] leading-[1.1] font-normal tracking-[-0.02em] text-[#858585]">
                {helperText}
            </p>
            <ul className="flex flex-col gap-2">
                {options.map((option) => (
                    <li key={option}>
                        <SelectableCard
                            title={option}
                            selected={value === option}
                            onClick={() => onSelect(option)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
